import { render, staticRenderFns } from "./ReportingSettings.vue?vue&type=template&id=bece962e"
import script from "./ReportingSettings.vue?vue&type=script&lang=js"
export * from "./ReportingSettings.vue?vue&type=script&lang=js"
import style0 from "./ReportingSettings.vue?vue&type=style&index=0&id=bece962e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports